import angular from 'angular';

import editTrainingDocumentDirective from './edit-document.directive';
import EditTrainingDocumentDirectiveController from './edit-document.directive.controller';

import message from './document.messages.html';

export default angular.module('app.components.admin.trainingAdministration.media.editMedia.editDocumentDialog', [])
  .directive('editTrainingDocument', editTrainingDocumentDirective)
  .controller('EditTrainingDocumentDirectiveController', EditTrainingDocumentDirectiveController)
  .run(($templateCache) => {
    $templateCache.put('document.messages.html', message);
  })
  .name;

console.log('app.components.admin.trainingAdministration.media.editMedia.editDocumentDialog created');
